import React from "react"
import { Box } from "@chakra-ui/react"
import { Headline } from "../section/Headline"
import { Container } from "../layout/Container"

export function TextBlock({ title, text }) {
  return (
    <Box
      pt={{ base: `30px`, md: `30px`, lg: `30px` }}
      pb={{ base: `30px`, md: `30px`, lg: `30px` }}
      id={title?.toLowerCase()?.split(" ").join("-")}
    >
      <Container>
        <Headline
          p={0}
          title={title}
          description={text}
          descriptionProps={{
            fontSize: { base: 20 },
            lineHeight: { base: `30px` },
            mt: { base: `24px` },
          }}
        />
      </Container>
    </Box>
  )
}
